import { Paper } from '@mui/material';
import { VideoItem } from '../VideoCarousel/VideoCarouselModal';
import { HeroVideoSearchResultItem } from './HeroVideoSearchResultItem';

interface HeroVideoSearchResultsProps {
  results: VideoItem[];
  onSelect: (video: VideoItem) => void;
}

export function HeroVideoSearchResults({ results, onSelect }: HeroVideoSearchResultsProps) {
  if (results.length === 0) {
    return null;
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        mt: 1,
        maxHeight: 300,
        overflowY: 'auto',
        borderRadius: 2,
      }}
    >
      {results.map((video) => (
        <HeroVideoSearchResultItem key={video.id} video={video} onSelect={onSelect} />
      ))}
    </Paper>
  );
}
